import PageContainerFull from "../components/layout/PageContainerFull";
import PageSection from "../components/layout/PageSection";
import PageTitle from "../components/layout/PageTitle";
import Card from "../components/forms/Card";
import axios from "axios";
import {Apis} from "../util/data";
import {useEffect, useState} from "react";
import logo from "../img/logo.png"
import useWindowDimensions from "../hooks/useWindowDimensions";

const Activate = () => {

  const [token,setToken] = useState('')
  const [mensaje,setMensaje] = useState('Activando cuenta, espere por favor')

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const confirmToken = urlParams.get('confirmToken');
    if (confirmToken) {
      setToken(confirmToken);
    } else {
      setMensaje("Error al obtener el token")
    }
  }, []);

  const { height } = useWindowDimensions();

  const activateAccount =async () =>{
    try {
      const {data} = await axios.get(Apis.PROD + "/api/v1/auth/register/activate/" + token)
      if (data) {
        setMensaje(data)
      }
    }
    catch (error){
      setMensaje("Error al activar su cuenta. Comuniquese con un administrador al correo contactenos@promsalud.com")
      console.log(error)
    }
  }

  useEffect(()=>{
    if(token.length > 0) {
      activateAccount().catch()
    }
  },[token])

  return(
      <PageContainerFull style={{padding: 0}}>
        <div style={{height: '100%',width:'100%'}}>
          <div style={{padding: 10, height: height, display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <img style={{height: 240,width: 240}} src={logo} alt={'logo'}/>
            <Card padding style={{width: 500}}>
              <PageSection style={{display:'flex', justifyContent: 'center', alignItems: 'center'}}>
                <PageTitle title={mensaje}/>
              </PageSection>
            </Card>
          </div>
        </div>
      </PageContainerFull>
  )
}

export default Activate
